import _createClass from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/mark/g/maejohns/www/maejohns.com/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { pretty } from 'js-object-pretty-print';

function createPropString(props) {
  if (!props) {
    return '';
  } // const prettyProps = JSON.stringify(props)


  var prettyProps = pretty(props);

  if (prettyProps.length <= 2) {
    return '';
  }

  return prettyProps.substring(1, prettyProps.length - 2);
}

export var ZError =
/*#__PURE__*/
function (_Error) {
  _inherits(ZError, _Error);

  function ZError(msg, props) {
    var _this;

    _classCallCheck(this, ZError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZError).call(this, "".concat(msg).concat(createPropString(props))));
    _this.name = 'ZError';
    return _this;
  }

  return ZError;
}(_wrapNativeSuper(Error));
export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["Trace"] = 0] = "Trace";
  LogLevel[LogLevel["Debug"] = 1] = "Debug";
  LogLevel[LogLevel["Info"] = 2] = "Info";
  LogLevel[LogLevel["Warn"] = 3] = "Warn";
  LogLevel[LogLevel["Error"] = 4] = "Error";
})(LogLevel || (LogLevel = {}));

function levelStringToEnum(level) {
  switch (level) {
    case 'trace':
      return LogLevel.Trace;

    case 'debug':
      return LogLevel.Debug;

    case 'info':
      return LogLevel.Info;

    case 'warn':
      return LogLevel.Warn;

    case 'error':
      return LogLevel.Error;

    default:
      throw new Error('unknown log level: ' + level);
  }
}
/**
 * Simple log wrapper for structured, leveled logging in React Native.
 * In the future this class can be extended to export business intelligence,
 * telemetry, log contexts, etc. None of that is necessary right now.
 */


export var Logger =
/*#__PURE__*/
function () {
  function Logger() {
    var _this2 = this;

    var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LogLevel.Info;

    _classCallCheck(this, Logger);

    this.logLevel = logLevel;

    this.trace = function (msg, props) {
      if (_this2.logLevel <= LogLevel.Trace) {
        _this2.log('TRCE', msg, props);
      }
    };

    this.debug = function (msg, props) {
      if (_this2.logLevel <= LogLevel.Debug) {
        _this2.log('DBUG', msg, props);
      }
    };

    this.info = function (msg, props) {
      if (_this2.logLevel <= LogLevel.Info) {
        _this2.log('INFO', msg, props);
      }
    };

    this.warn = function (msg, props) {
      if (_this2.logLevel <= LogLevel.Warn) {
        _this2.log('WARN', msg, props);
      }
    };

    this.error = function (msg, props) {
      if (_this2.logLevel <= LogLevel.Error) {
        _this2.log('EROR', msg, props);
      }

      return new ZError(msg, props);
    };
  }

  _createClass(Logger, [{
    key: "log",
    value: function log(level, msg, props) {
      var propString = createPropString(props);
      console.log("".concat(level, ": ").concat(msg).concat(propString));
    }
  }]);

  return Logger;
}(); // global singleton, set by init in App.js

export var log = new Logger(levelStringToEnum('debug'));
export function initLogger(level) {
  log = new Logger(levelStringToEnum(level));
}